<div class="content">
  <mat-icon class="close" mat-dialog-close>close</mat-icon>
  <article [innerHTML]="content"></article>
  <div
    class="btn"
    (click)="openPlatform()"
    [ngStyle]="{ background: data.btn2, color: data.fontcolor2 }"
  >
    {{ data.txt5 }}
  </div>
</div>
